import React from "react";
import { Card, Row, Col, Statistic, Grid } from "antd";
const { useBreakpoint } = Grid;
import { 
    ShoppingOutlined, 
    CheckCircleOutlined, 
    UserOutlined, 
    CarOutlined, 
    FieldTimeOutlined,
    CloseCircleOutlined
} from "@ant-design/icons";
import CountUp from "react-countup";

interface DashboardCardsProps {
    todayOrders: number;
    assignedOrders: number;
    totalDrivers: number;
    onlineDrivers: number;
    orders: number;
    offlineDrivers: number;
}

const DashboardCards: React.FC<DashboardCardsProps> = ({
    todayOrders,
    assignedOrders,
    totalDrivers,
    onlineDrivers,
    orders,
    offlineDrivers
}) => {
    const screens = useBreakpoint();
    const isMobile = !screens.md;
    const formatter = (value: any) => <CountUp end={Number(value) || 0} duration={1.2} separator="," />;

    const stats = [
        {
            title: "Total Orders",
            value: orders,
            icon: <ShoppingOutlined style={{ fontSize: 22, color: "#2563eb" }} />,
            bgLight: "#eff6ff",
            borderColor: "#bfdbfe",
            textColor: "#1e40af"
        },
        {
            title: "Today's Orders",
            value: todayOrders,
            icon: <FieldTimeOutlined style={{ fontSize: 22, color: "#f59e0b" }} />,
            bgLight: "#fffbeb",
            borderColor: "#fde68a",
            textColor: "#b45309"
        },
        {
            title: "Assigned Orders",
            value: assignedOrders,
            icon: <CheckCircleOutlined style={{ fontSize: 22, color: "#10b981" }} />,
            bgLight: "#ecfdf5",
            borderColor: "#a7f3d0",
            textColor: "#047857"
        },
        {
            title: "Fleet Drivers",
            value: totalDrivers,
            icon: <UserOutlined style={{ fontSize: 22, color: "#8b5cf6" }} />,
            bgLight: "#f5f3ff",
            borderColor: "#ddd6fe",
            textColor: "#6d28d9"
        },
        {
            title: "Active / Online",
            value: onlineDrivers,
            icon: <CarOutlined style={{ fontSize: 22, color: "#06b6d4" }} />,
            bgLight: "#ecfeff",
            borderColor: "#a5f3fc",
            textColor: "#0e7490"
        },
        {
            title: "Offline Drivers",
            value: offlineDrivers,
            icon: <CloseCircleOutlined style={{ fontSize: 22, color: "#64748b" }} />,
            bgLight: "#f8fafc",
            borderColor: "#e2e8f0",
            textColor: "#475569"
        }
    ];

    return (
        <div style={{ marginBottom: 20 }}>
            {/* Responsive Grid: 1 col on small phones, 2 on phones, 3 on tablet, 6 on desktop */}
            <Row gutter={[16, 16]}>
                {stats.map((item, idx) => (
                    <Col xs={12} sm={12} md={8} xl={4} key={idx}>
                        <Card
                            hoverable
                            style={{
                                borderRadius: 12,
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.03)',
                                transition: 'all 0.25s ease',
                                height: '100%',
                                background: '#ffffff',
                                overflow: 'hidden',
                                position: 'relative'
                            }}
                            styles={{ body: { padding: isMobile ? '12px 14px' : '16px 18px' } }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                                <div style={{ minWidth: 0 }}>
                                    <div style={{
                                        fontSize: isMobile ? 10 : 12.5,
                                        fontWeight: 600,
                                        color: '#64748b',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.04em',
                                        marginBottom: isMobile ? 4 : 6,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }}>
                                        {item.title}
                                    </div>
                                    <div style={{
                                        fontSize: isMobile ? 20 : 24,
                                        fontWeight: 700,
                                        color: '#0f172a',
                                        lineHeight: 1.2,
                                        fontFamily: '"Plus Jakarta Sans", sans-serif'
                                    }}>
                                        {formatter(item.value)}
                                    </div>
                                </div>
                                <div style={{
                                    width: isMobile ? 36 : 44,
                                    height: isMobile ? 36 : 44,
                                    borderRadius: 10,
                                    background: item.bgLight,
                                    border: `1px solid ${item.borderColor}`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                }}>
                                    {item.icon}
                                </div>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default DashboardCards;

